import type { ICampaignGroup } from '../types';

import { useCampaignGroupUpdateMutation } from '~/api/graphql/mutations/campaignGroupUpdate.generated';

export const useMutationCampaignGroupBase = () => {
  const updateCampaignGroupMutation = useCampaignGroupUpdateMutation();

  const updateCampaignGroupDetails = async (data: ICampaignGroup) => {
    const { campaignGroupUpdate } = await updateCampaignGroupMutation.mutateAsync({
      id: data.id,
      input: {
        priority: data.priority,
        trafficRate: data.trafficRate,
        targetChannels: data.targetChannels,
        targetDevices: data.targetDevices,
        targetVisitorTypes: data.targetVisitorTypes,
        ...(data.conditions ? { conditions: data.conditions } : {}),
      },
    });
    return campaignGroupUpdate;
  };
  const updateCampaignGroupBase = async (data: ICampaignGroup): Promise<ICampaignGroup> => {
    if (!data) throw new Error('Campaign or variants not found');

    const dataUpdated = await updateCampaignGroupDetails(data);

    if (!dataUpdated) {
      throw new Error('Failed to update data');
    }

    return {
      ...data,
      ...dataUpdated,
    } as ICampaignGroup;
  };

  return {
    updateCampaignGroupBase,
  };
};
